import React, { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { useNavigate } from 'react-router-dom';
import useScrollAnimation from './UseScrollAnimation';

const Sobre = () => {
  useScrollAnimation();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
      
      <main className="flex-grow">
        {/* Banner Section - Reduzido o padding vertical (py-16) no mobile */}
        <section className="relative bg-usifresa-blue py-16 lg:py-32 overflow-hidden reveal">
          <div className="absolute inset-0 opacity-20 pointer-events-none">
             <img src="/fachada.jpeg" alt="fachada Usifresa" className="w-full h-full object-cover" />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-usifresa-blue via-usifresa-blue/90 to-transparent"></div>
          
          {/* Adicionado px-4 sm:px-6 para melhor margem mobile */}
          <div className="container mx-auto px-4 sm:px-6 md:px-12 relative z-10 flex flex-col lg:flex-row items-center gap-10 lg:gap-12">
            <div className="flex-1 lg:pr-12">
              {/* Título text-3xl no mobile */}
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-sans font-black text-white mb-6 md:mb-8 pt-10">Sobre nós</h1>
              
              <div className="h-1 bg-usifresa-orange mb-8 md:mb-10 w-full animate-[linhaGrow_2s_ease-out_forwards]"></div>
              
              {/* Textos levemente menores (text-base) no celular */}
              <div className="space-y-5 md:space-y-6 text-white text-base md:text-lg leading-relaxed font-light">
                <p>
                  A Usifresa é uma empresa familiar fundada em 2003, sediada em Serrana no interior de São Paulo, tendo sua atividade principal voltada para o desenvolvimento de projetos e fabricação de maquinas e equipamentos para conversão de papeis da linha Tissue em sua diversas linhas e seguimentos, envolvendo a conversão de papeis relacionados a higiene e saúde, dentre esses Papel Toalha interfolhado, Papel Toalha em Bobinas, Papel Higiênico, Lençol Hospitalar e Guardanapos em geral.
                </p>
                <p>
                  Atualmente é líder no seu seguimento de mercado, contendo na sua planta fabril equipamentos automatizados de usinagem CNC (controle numéricos computadorizados) de ultima geração, instrumentos de controle e aferição, softwares para desenvolvimento de projetos 3D e seus devidos pós processadores inerentes a programação, bem como de gestão ERP voltado ao controle de toda cadeia produtiva, departamento fiscal, financeiro, RH, e relacionamento B2B com clientes e fornecedores.
                </p>
                <p>
                  No intuito de suprir as necessidades do mercado, a Usifresa segue desenvolvendo produtos e serviços que visam baixar custos e aumentar a produtividade, consolidando sua presença no segmento, em todo território nacional e internacional.
                </p>
              </div>
            </div>
            <div className="flex-1 w-full relative group mt-4 lg:mt-0">
              <div className="absolute -inset-4 bg-usifresa-orange/20 rounded-3xl blur-xl group-hover:bg-usifresa-orange/30 transition-all duration-500"></div>
              {/* Altura reduzida (h-[250px]) para não tomar a tela inteira do celular */}
              <img src="/fachada.jpeg" alt="Fachada Usifresa" className="relative w-full rounded-2xl shadow-2xl object-cover h-[250px] sm:h-[350px] lg:h-[600px] border border-white/10" />
            </div>
          </div>
        </section>

        {/* Valores Section - py-16 no mobile e px-4 para as laterais */}
        <section className="py-16 md:py-24 container mx-auto px-4 sm:px-6 md:px-12 reveal">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
            <div className="lg:w-1/3">
              
              <div className="flex items-center gap-4 mb-5 md:mb-6">
                <span className="w-12 h-[3px] bg-usifresa-orange"></span>
                <span className="text-xs md:text-sm font-black text-usifresa-blue uppercase tracking-[0.3em]">
                  Nossos Valores
                </span>
              </div>
              
              {/* Título text-3xl no mobile */}
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-usifresa-blue mb-6 md:mb-8 leading-tight">
                Compromisso <br className="hidden lg:block"/> com a excelência
              </h2>
              
              <div className="h-1 bg-usifresa-orange mb-6 md:mb-8 w-full"></div>
              
              <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-8 md:mb-10">
                Os valores da Usifresa são pautados na excelência, inovação e compromisso com nossos clientes. Priorizamos a qualidade, a equipe altamente treinada, preços justos e o constante aprimoramento para oferecer soluções de alta performance em nossos produtos e serviços.
              </p>
              
              {/* Botões adaptados para mobile (w-full, gap-3, py-3.5) */}
              <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
                <button 
                  onClick={() => navigate("/contato")}
                  className="group flex items-center justify-center gap-3 w-full sm:w-auto px-6 py-3.5 md:py-4 bg-gradient-custom rounded-full text-white text-sm md:text-base font-bold shadow-[0_4px_14px_0_rgba(0,195,255,0.39)] hover:shadow-[0_6px_20px_rgba(0,195,255,0.23)] hover:-translate-y-1 transition-all duration-300"
                >
                  <span>Entre em contato</span>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 74 74" className="w-5 h-5 md:w-6 md:h-6 transform group-hover:translate-x-1 transition-transform">
                    <circle strokeWidth="3" stroke="#fff" r="35.5" cy="37" cx="37" stroke="orange"></circle>
                    <path fill="white" d="M25 35.5C24.1716 35.5 23.5 36.1716 23.5 37C23.5 37.8284 24.1716 38.5 25 38.5V35.5ZM49.0607 38.0607C49.6464 37.4749 49.6464 36.5251 49.0607 35.9393L39.5147 26.3934C38.9289 25.8076 37.9792 25.8076 37.3934 26.3934C36.8076 26.9792 36.8076 27.9289 37.3934 28.5147L45.8787 37L37.3934 45.4853C36.8076 46.0711 36.8076 47.0208 37.3934 47.6066C37.9792 48.1924 38.9289 48.1924 39.5147 47.6066L49.0607 38.0607ZM25 38.5L48 38.5V35.5L25 35.5V38.5Z"></path>
                  </svg>
                </button>
                <button 
                  onClick={() => window.open('/pdfs/catalogo-completo-usifresa.pdf', '_blank')}
                  className="w-full sm:w-auto px-6 py-3.5 md:py-4 bg-gray-200 hover:bg-gray-300 text-gray-800 text-sm md:text-base font-bold rounded-full transition-colors flex items-center justify-center gap-2"
                >
                  <svg className="w-4 h-4 md:w-5 md:h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                  Catálogo
                </button>
              </div>
            </div>

            <div className="lg:w-2/3 grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-8 lg:mt-0">
              {/* Padding dos cards reduzido para p-6 no mobile */}
              <div className="bg-white p-6 sm:p-8 rounded-3xl shadow-lg border border-gray-300 hover:-translate-y-2 transition-transform duration-300 flex flex-col">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-usifresa-blue/5 flex items-center justify-center mb-5 md:mb-6">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7 md:w-8 md:h-8 fill-usifresa-blue" viewBox="0 0 16 16">
                    <path d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/>
                    <path d="m5.93 6.704-.846 8.451a.768.768 0 0 0 1.523.203l.81-4.865a.59.59 0 0 1 1.165 0l.81 4.865a.768.768 0 0 0 1.523-.203l-.845-8.451A1.5 1.5 0 0 1 10.5 5.5L13 2.284a.796.796 0 0 0-1.239-.998L9.634 3.84a.7.7 0 0 1-.33.235c-.23.074-.665.176-1.304.176-.64 0-1.074-.102-1.305-.176a.7.7 0 0 1-.329-.235L4.239 1.286a.796.796 0 0 0-1.24.998l2.5 3.216c.317.316.475.758.43 1.204Z"/>
                  </svg>
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-usifresa-blue mb-3 md:mb-4">Equipe</h3>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed">Contamos com uma equipe altamente treinada para melhor atendê-lo.</p>
              </div>

              <div className="bg-white p-6 sm:p-8 rounded-3xl shadow-lg border border-gray-300 hover:-translate-y-2 transition-transform duration-300 flex flex-col sm:translate-y-8">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-usifresa-blue/5 flex items-center justify-center mb-5 md:mb-6">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7 md:w-8 md:h-8 fill-usifresa-blue" viewBox="0 0 16 16">
                    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                  </svg>
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-usifresa-blue mb-3 md:mb-4">Qualidade</h3>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed">Trabalhamos com as melhores marcas, peças e máquinas do mercado.</p>
              </div>

              <div className="bg-white p-6 sm:p-8 rounded-3xl shadow-lg border border-gray-300 hover:-translate-y-2 transition-transform duration-300 flex flex-col">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-usifresa-blue/5 flex items-center justify-center mb-5 md:mb-6">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7 md:w-8 md:h-8 fill-usifresa-blue" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8m5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0"/>
                    <path d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195z"/>
                    <path d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083q.088-.517.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1z"/>
                    <path d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 6 6 0 0 1 3.13-1.567"/>
                  </svg>
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-usifresa-blue mb-3 md:mb-4">Preço justo</h3>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed">Trabalhamos com o melhor custo-benefício pra todo território nacional.</p>
              </div>
            </div>
          </div>
        </section>

      </main>

      <Footer />
    </div>
  );
};
 
export default Sobre;